const LEET: Record<string, string> = {
  '0': 'o',
  '1': 'i',
  '3': 'e',
  '4': 'a',
  '5': 's',
  '7': 't',
  '@': 'a',
  $: 's',
  '!': 'i',
};

/** Exact tokens (and simple inflections). Short words stay token-only to avoid "class" / "Essex". */
const BLOCKED_STEMS = [
  'anal',
  'anus',
  'arse',
  'ass',
  'asshole',
  'bastard',
  'bitch',
  'blowjob',
  'boob',
  'boobs',
  'chink',
  'clit',
  'cock',
  'coon',
  'crap',
  'cum',
  'cunt',
  'damn',
  'dick',
  'dildo',
  'dyke',
  'fag',
  'faggot',
  'fags',
  'fuck',
  'fucker',
  'fucking',
  'gook',
  'handjob',
  'hooker',
  'horny',
  'jizz',
  'kike',
  'kys',
  'milf',
  'nazi',
  'negro',
  'nigga',
  'nigger',
  'nipple',
  'nsfw',
  'nude',
  'nudes',
  'orgasm',
  'penis',
  'piss',
  'porn',
  'porno',
  'pussy',
  'rape',
  'rapist',
  'retard',
  'retarded',
  'rimjob',
  'sex',
  'sexual',
  'sexy',
  'shit',
  'slut',
  'spic',
  'splooge',
  'sperm',
  'tits',
  'titty',
  'tranny',
  'twat',
  'vagina',
  'wank',
  'wetback',
  'whore',
  'wop',
  'xxx',
];

/** Compact-substring matches for slurs, compounds, and common evasions. */
const BLOCKED_COMPACT = [
  'nigger',
  'niggers',
  'nigga',
  'niggas',
  'faggot',
  'faggots',
  'retard',
  'kike',
  'chink',
  'spic',
  'wetback',
  'childporn',
  'childsex',
  'loli',
  'lolita',
  'pedophile',
  'paedophile',
  'pedo',
  'rapist',
  'nazi',
  'blowjob',
  'handjob',
  'rimjob',
  'onlyfans',
  'pornhub',
  'porn',
  'xvideos',
  'masturbat',
  'jerkoff',
  'deepthroat',
  'cumshot',
  'asshole',
  'bullshit',
  'dumbass',
  'jackass',
  'goddamn',
];

const EVASION_TOKENS = new Set([
  'fck',
  'fuk',
  'fuq',
  'fuc',
  'phuck',
  'fux',
  'sht',
  'shyt',
  'dic',
  'dik',
  'c0ck',
  'secks',
  'sexx',
  'sexyy',
]);

function inflect(stem: string): string[] {
  if (stem.length < 3) return [stem];
  const out = new Set([stem, `${stem}s`, `${stem}es`, `${stem}ed`, `${stem}er`, `${stem}ers`]);
  if (stem.endsWith('e')) out.add(`${stem}d`);
  else out.add(`${stem}ing`);
  if (stem.endsWith('y') && stem.length > 3) {
    const base = stem.slice(0, -1);
    out.add(`${base}ies`);
    out.add(`${base}ied`);
  }
  return [...out];
}

const BLOCKED_TOKENS = new Set(BLOCKED_STEMS.flatMap(inflect));

export const CLEAN_LANGUAGE_ERROR = 'Keep it PG — no vulgar or sexual language.';

export function compactText(value: string): string {
  return value
    .toLowerCase()
    .split('')
    .map((ch) => LEET[ch] ?? ch)
    .join('')
    .replace(/[^a-z0-9]/g, '');
}

function tokensOf(value: string): string[] {
  return value
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .map((token) => compactText(token))
    .filter(Boolean);
}

export function hasBlockedLanguage(raw: string): boolean {
  const compact = compactText(raw);
  for (const slur of BLOCKED_COMPACT) {
    if (compact.includes(slur)) return true;
  }
  for (const token of tokensOf(raw)) {
    if (BLOCKED_TOKENS.has(token) || EVASION_TOKENS.has(token)) return true;
  }
  return false;
}

export function blockedLanguageError(raw: string): string | null {
  return hasBlockedLanguage(raw) ? CLEAN_LANGUAGE_ERROR : null;
}
